import { render, staticRenderFns } from "./MainUserInfoView.vue?vue&type=template&id=6c2277c7&scoped=true"
import script from "./MainUserInfoView.vue?vue&type=script&lang=js"
export * from "./MainUserInfoView.vue?vue&type=script&lang=js"
import style0 from "./MainUserInfoView.vue?vue&type=style&index=0&id=6c2277c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2277c7",
  null
  
)

export default component.exports